<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    initials: string;
    width?: number;
    height?: number;
    fontSize?: number;
    imageUrl?: string;
    loading?: boolean;
  }>(),
  {
    width: 48,
    height: 48,
    fontSize: 22,
    imageUrl: '',
    loading: false,
  },
);
</script>

<template>
  <div class="ui-avatar" :class="{ 'is-loading': props.loading }">
    <img
      v-if="props.imageUrl"
      id="user-photo"
      alt="User Photo"
      :src="props.imageUrl"
    />
    <div v-else class="initials">{{ props.initials }}</div>
    <div v-if="props.loading" class="shimmer" />
  </div>
</template>

<style lang="scss" scoped>
.ui-avatar {
  border-radius: var(--border-radius-circle);
  width: v-bind('`${props.width}px`');
  height: v-bind('`${props.height}px`');
  border: px(2) solid var(--color-primary-200);
  transition:
    border-width 0.15s ease,
    border-color 0.15s ease;
  background: linear-gradient(
    135deg,
    var(--color-primary-100),
    var(--color-primary-500)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;

  img,
  .initials {
    transition: transform var(--duration-base) var(--ease-standard);
  }
  color: var(--color-gray-900);
}

.initials {
  font-size: v-bind('`${props.fontSize}px`');
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-ratio-100);
}

.shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    105deg,
    transparent 30%,
    rgba(255, 255, 255, 0.45) 50%,
    transparent 70%
  );
  background-size: 200% 100%;
  animation: shimmer-sweep 1.2s infinite;
}

@keyframes shimmer-sweep {
  from {
    background-position: 200% center;
  }
  to {
    background-position: -200% center;
  }
}
</style>
